import React from "react";
import styled from "styled-components";

import iconPhoneGrey from "../../assets/icons-main/phone-grey.png";
import iconPhoneWhite from "../../assets/icons-main/phone-white.png";
import iconMailGrey from "../../assets/icons-main/mail-grey.png";
import iconMailWhite from "../../assets/icons-main/mail-white.png";

const ContactStepWrapper = styled.div`
  h4 {
    font-size: 26px;
    line-height: 35px;
    max-width: 400px;
    margin: 50px auto 60px;
    text-align: center;
    text-transform: none;
  }
  form {
    margin-bottom: 60px;
  }
`;

const TypeOfContact = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;

  @media (max-width: 767.98px) {
    flex-direction: column;
  }

  button {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-end;
    justify-content: center;
    padding: 30px;
    flex: 49% 0;
    border: none;
    background-color: #fff;
    text-transform: uppercase;
    font-family: "Roboto Mono",
    font-size: 16px;
    height: 225px;
    cursor: pointer;
    text-align: center;



    @media (max-width: 767.98px) {
      flex: 100% 0;
    }

    img {
      height: 85px;
      margin-bottom: 35px;
      /* display: block;
      margin: 0 auto; */

    }

    span {
      display: block;
      width: 100%;
    }

    &.active {
      background-color: #ff5000;
      color: #fff;
    }
    &:focus {
      outline: none;
      border: none;
    }
  }
`;

class ContactStep2 extends React.Component {
  render() {
    const mailActive = this.props.values.typeOfContact === "mail";

    return (
      <ContactStepWrapper>
        <h4>Wskaż preferowany typ kontaktu.</h4>
        <TypeOfContact>
          <button
            onClick={() => this.props.onChange("typeOfContact", "phone")}
            className={!mailActive ? "active" : ""}
          >
            {mailActive && <img src={iconPhoneGrey} alt="Youtube logo white" />}
            {!mailActive && (
              <img src={iconPhoneWhite} alt="Youtube logo white" />
            )}
            <span>Telefoniczny</span>
          </button>
          <button
            className={mailActive ? "active" : ""}
            onClick={() => this.props.onChange("typeOfContact", "mail")}
          >
            {!mailActive && <img src={iconMailGrey} alt="Youtube logo white" />}
            {mailActive && <img src={iconMailWhite} alt="Youtube logo white" />}
            <span>Mailowy</span>
          </button>
        </TypeOfContact>
      </ContactStepWrapper>
    );
  }
}

export default ContactStep2;
